'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _ControlLabel = require('react-bootstrap/lib/ControlLabel');

var _ControlLabel2 = _interopRequireDefault(_ControlLabel);

var _Form = require('react-bootstrap/lib/Form');

var _Form2 = _interopRequireDefault(_Form);

var _FormControl = require('react-bootstrap/lib/FormControl');

var _FormControl2 = _interopRequireDefault(_FormControl);

var _FormGroup = require('react-bootstrap/lib/FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _components = require('../../components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _reactIntl = require('react-intl');

var _NoResults = require('./NoResults');

var _NoResults2 = _interopRequireDefault(_NoResults);

var _preventDefault = require('../../utils/preventDefault');

var _preventDefault2 = _interopRequireDefault(_preventDefault);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SearchStatus = require('./SearchStatus');

var _SearchStatus2 = _interopRequireDefault(_SearchStatus);

var _PaginateSortFilter = require('./PaginateSortFilter.scss');

var _PaginateSortFilter2 = _interopRequireDefault(_PaginateSortFilter);

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIEWS_TO_SHOW = [24, 48, 72, 96, 120, 'all'];

var PaginateSortFilter = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(PaginateSortFilter, _Component);

    function PaginateSortFilter(props, context) {
        (0, _classCallCheck3.default)(this, PaginateSortFilter);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PaginateSortFilter.__proto__ || (0, _getPrototypeOf2.default)(PaginateSortFilter)).call(this, props, context));

        _this.handlePageSizeChange = function (event) {
            _this.changePageSize(event.target.value);
        };

        _this.handleSearchChange = function (event) {
            _this.setSearch(event.target.value);
        };

        _this.handleSortChange = function (event) {
            var value = event.target.value;

            _this.props.replaceQueryParam({ sort: value });
        };

        _this.changePage = function (selected) {
            var page = selected + 1; // selected is base 0, we need base 1;
            if (selected === 0) {
                _this.props.removeQueryParam('page');
            } else if (_this.props.page !== page) {
                _this.props.pushQueryParam({ page: page });
            }
        };

        _this.changePageSize = function (pageSize) {
            // it's necessary to manually set the page size before navigating
            // because we need to read it off the cookie, not the params.
            // at some point this might enjoy a refactor, consolidating this
            // with the pattern used in the search page.
            _this.props.changePaginationPageSize(pageSize);
            _this.props.pushQueryParam({});
        };

        _this.setSearch = function (value) {
            if (value) {
                var search = value.toLowerCase().trim();
                _this.props.replaceQueryParam({ terms: search });
            } else {
                _this.props.removeQueryParam('terms');
            }
        };

        _this.mapViewOptions = function (option, index) {
            var label = option === 'all' ? _this.context.intl.formatMessage({ id: option }) : option;
            return (0, _jsx3.default)('option', {
                value: option
            }, index, label);
        };

        _this.mapSortByOptions = function (option, index) {
            var label = _this.context.intl.formatMessage({ id: option.toLowerCase() });
            return (0, _jsx3.default)('option', {
                value: option
            }, index, label);
        };

        _this.clearSearch = function () {
            _this.setSearch('');
            _this.input.value = '';
        };

        _this.preventDefault = _preventDefault2.default;

        _this.setSearch = (0, _debounce2.default)(_this.setSearch, 300);
        return _this;
    }

    (0, _createClass3.default)(PaginateSortFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.searchTerms) {
                this.input.value = this.props.searchTerms;
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'className', 'empty', 'emptyMessage', 'filteredItemCount', 'isLoading', 'items', 'page', 'pageSize', 'pathname', 'searchTerms', 'sortOptions', 'sortOrder', 'throbberMessage', 'totalItemsCount', 'viewsToShow']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                children = _props.children,
                className = _props.className,
                baseUrl = _props.baseUrl,
                empty = _props.empty,
                emptyMessage = _props.emptyMessage,
                filteredItemCount = _props.filteredItemCount,
                isLoading = _props.isLoading,
                items = _props.items,
                page = _props.page,
                pageSize = _props.pageSize,
                pathname = _props.pathname,
                searchTerms = _props.searchTerms,
                sortOptions = _props.sortOptions,
                sortOrder = _props.sortOrder,
                throbberMessage = _props.throbberMessage,
                totalItemsCount = _props.totalItemsCount,
                type = _props.type,
                viewsToShow = _props.viewsToShow;
            var formatMessage = this.context.intl.formatMessage;


            var viewOptions = viewsToShow.map(this.mapViewOptions);
            var sortByOptions = (0, _keys2.default)(sortOptions).map(this.mapSortByOptions);
            var placeholderMessage = isLoading ? formatMessage({ id: 'loading' }) : totalItemsCount + ' ' + type;

            return (0, _jsx3.default)('div', {
                className: _PaginateSortFilter2.default['paginate-sort-filter'] + ' ' + className
            }, void 0, !empty && (0, _jsx3.default)(_Form2.default, {
                className: _PaginateSortFilter2.default.controls,
                inline: true,
                onSubmit: this.preventDefault
            }, void 0, (0, _jsx3.default)(_FormGroup2.default, {
                className: _PaginateSortFilter2.default.search,
                controlId: 'search',
                validationState: 'success'
            }, void 0, (0, _jsx3.default)(_ControlLabel2.default, {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'search'
            }), ':\xA0'), (0, _jsx3.default)(_FormControl2.default, {
                type: 'search',
                inputRef: function inputRef(ref) {
                    _this2.input = ref;
                },
                placeholder: placeholderMessage,
                onChange: this.handleSearchChange
            }), (0, _jsx3.default)(_FormControl2.default.Feedback, {
                bsClass: _PaginateSortFilter2.default['search-icon']
            })), isLoading && (0, _jsx3.default)('div', {
                className: _PaginateSortFilter2.default['my-bids-throbber']
            }, void 0, (0, _jsx3.default)(_caterwaulComponents.Throbber, {
                className: _PaginateSortFilter2.default.throbber,
                color: '#0097BA'
            }), throbberMessage), (0, _jsx3.default)(_components.Input, {
                className: _PaginateSortFilter2.default['page-size'],
                label: (0, _jsx3.default)('span', {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'view'
                }), ':\xA0'),
                onChange: this.handlePageSizeChange,
                placeholder: formatMessage({ id: 'select' }),
                small: true,
                type: 'select',
                value: pageSize
            }, void 0, viewOptions), (0, _jsx3.default)(_components.Input, {
                className: _PaginateSortFilter2.default['sort-by'],
                label: (0, _jsx3.default)('span', {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'sort'
                }), ':\xA0'),
                onChange: this.handleSortChange,
                placeholder: formatMessage({ id: 'select' }),
                small: true,
                type: 'select',
                value: sortOrder
            }, void 0, 'options=', sortByOptions)), (0, _jsx3.default)(_SearchStatus2.default, {
                itemCount: filteredItemCount,
                search: searchTerms,
                clear: this.clearSearch
            }), !empty ? (0, _jsx3.default)('div', {
                className: _PaginateSortFilter2.default['grid-wrapper']
            }, void 0, children) : (0, _jsx3.default)(_NoResults2.default, {}, void 0, emptyMessage), !!items.length && (0, _jsx3.default)(_components.PaginationWrapper, {
                availableViews: VIEWS_TO_SHOW,
                baseUrl: baseUrl,
                items: items,
                filteredItemCount: filteredItemCount,
                onPageChange: this.changePage,
                onPageSizeChange: this.changePageSize,
                onSubmit: this.preventDefault,
                page: page,
                pageSize: pageSize,
                pathname: pathname,
                totalItemsCount: totalItemsCount
            }));
        }
    }]);
    return PaginateSortFilter;
}(_react.Component), _class.contextTypes = {
    intl: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
    className: '',
    isLoading: false,
    items: [],
    page: 1,
    searchTerms: '',
    throbberMessage: '',
    totalItemsCount: 0,
    type: 'lots',
    viewsToShow: VIEWS_TO_SHOW
}, _temp);
exports.default = PaginateSortFilter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/PaginateSortFilter.js
// module id = VxOq
// module chunks = 46